import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate, Link } from 'react-router-dom';
import { USERS_URL_LOGIN } from '../constants';

function Login({ updateUserStatus }) {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();

    const loginDetails = { username, password };

    const postOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(loginDetails),
    };

    // Log login request details for debugging
    console.log('Sending login request with:', loginDetails);

    fetch(USERS_URL_LOGIN, postOptions)
      .then((response) => {
        console.log('Response Status:', response.status); // Log the response status
        return response.json(); // Parse the JSON from the response
      })
      .then((data) => {
        console.log('Response Data:', data); // Log the response data for debugging
        if (data.message === 'Login successful!') { // Ensure correct casing for keys
          console.log('Login successful!');
          updateUserStatus(true, data.userId, data.username);  // Pass UserId and Username (ensure correct casing)
          navigate('/');
        } else {
          console.log('Login failed:', data.message);
          updateUserStatus(false, '', '');  // Handle failed login
        }
      })
      .catch((error) => {
        console.error('Login failed:', error); // Log the error for debugging
        updateUserStatus(false, '', '');  // Handle error
      });
  };

  return (
    <div className="text-center mt-5" style={{ height: 'auto', display: 'flex', justifyContent: 'center' }}>
      <div>
        <h1 className="mb-4">Logga in</h1>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicName">
            <Form.Label>Användarkonto</Form.Label>
            <Form.Control
              type="text"
              placeholder="Skriv in användarnamnet"
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Lösenord</Form.Label>
            <Form.Control
              type="password"
              placeholder="Lösenord"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          <Button variant="primary" type="submit">
            Logga in
          </Button>
        </Form>

        <Link to="/Register">
          <Button className="mt-4">Skapa konto</Button>
        </Link>
      </div>
    </div>
  );
}

export default Login;
